module.exports = "<div class=\"list-item\" ng-repeat=\"(label, itemList) in Ctrl.list track by $index\">\n\t<ul>\n\t\t<list-item item=\"itemList\" label=\"label\"> </list-item>\n\t</ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/parent-list/templates/main-template.html
// module id = 330
// module chunks = 0